import { render, staticRenderFns } from "./PlatformAnalytics.vue?vue&type=template&id=f3495246&scoped=true"
import script from "./PlatformAnalytics.vue?vue&type=script&lang=js"
export * from "./PlatformAnalytics.vue?vue&type=script&lang=js"
import style0 from "./PlatformAnalytics.vue?vue&type=style&index=0&id=f3495246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3495246",
  null
  
)

export default component.exports